import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../Api/axios.instance";

const STATUS_COLORS = {
  Active: "#1976d2",
  Inactive: "#f57c00",
  Closed: "#d32f2f",
};

export default function Schools({
  schools,
  onSchoolChanged,
  onEditSchool,
  isAdminActive,
}) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const openAnchor = Boolean(anchorEl);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleAnchorClose = () => setAnchorEl(null);
  const handleIconClick = (row) => (e) => {
    setAnchorEl(e.currentTarget);
    setSelectedRow(row);
  };

  const _onDetailsClick = (details) => () => {
    navigate("/clusters/school/" + details.SchoolId, {
      state: { schoolData: details },
    });
    handleAnchorClose();
  };

  const _onEditClick = () => {
    if (onEditSchool) onEditSchool(selectedRow);
    handleAnchorClose();
  };

  const _onDeleteClick = () => {
    setConfirmOpen(true);
    handleAnchorClose();
  };

  const _confirmDelete = async () => {
    try {
      await axiosInstance.delete(`/schools/${selectedRow.SchoolId}`);
      if (onSchoolChanged) onSchoolChanged();
    } catch (error) {
      console.log(error?.response?.data?.message || error);
    }
    setConfirmOpen(false);
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell width={250}>School Name</TableCell>
            <TableCell align="center">Address</TableCell>
            <TableCell align="center">Registered</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center"># Rooms</TableCell>
            <TableCell align="center">Onwership Status</TableCell>
            <TableCell align="center">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schools.map((row, index) => (
            <TableRow
              key={String(index)}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.NameOfSchool}
              </TableCell>
              <TableCell align="center">{row.Address}</TableCell>
              <TableCell align="center">{row.Registered}</TableCell>
              <TableCell align="center">
                <span
                  style={{
                    color: STATUS_COLORS[row.Status?.trim()] || "#757575",
                    fontWeight: 600,
                  }}
                >
                  {row.Status?.trim() === "Inactive"
                    ? "InActive"
                    : row.Status?.trim()}
                </span>
              </TableCell>
              <TableCell align="center">{row.NoOfRooms}</TableCell>
              <TableCell align="center">{row.OwnerShipStatus}</TableCell>
              <TableCell align="center">
                <IconButton onClick={handleIconClick(row)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleAnchorClose}>
        <MenuItem onClick={_onDetailsClick(selectedRow)}>View Details</MenuItem>
        {isAdminActive && <MenuItem onClick={_onEditClick}>Edit</MenuItem>}
        {/* <MenuItem onClick={_onDeleteClick} sx={{ color: "error.main" }}>
          Delete
        </MenuItem> */}
      </Menu>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Delete School</DialogTitle>
        <DialogContent>
          Are you sure you want to delete "{selectedRow?.NameOfSchool}"?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button color="error" onClick={_confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
}
